import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f44c56e")

_pushScopeId("data-v-7f44c56e")
const _hoisted_1 = { class: "acu-frame" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("部位変更 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_body_parts_image = _resolveComponent("body-parts-image")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_multi_line_edit_box = _resolveComponent("multi-line-edit-box")
  const _component_acu_parts_modal = _resolveComponent("acu-parts-modal")

  return (_openBlock(), _createBlock("div", {
    class: ["frame", _ctx.$mq]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_body_parts_image, {
        direction: _ctx.direction[_ctx.resultIndex][_ctx.kartePartsIndex],
        partsId: _ctx.bodyParts[_ctx.resultIndex][_ctx.kartePartsIndex],
        acuList: _ctx.acuList,
        onAcu: _ctx.onClickAcu
      }, null, 8, ["direction", "partsId", "acuList", "onAcu"]),
      (!_ctx.readonly)
        ? (_openBlock(), _createBlock(_component_normal_button, {
            key: 0,
            class: "parts-button",
            state: "normal",
            onClick: _ctx.onChangeParts
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_multi_line_edit_box, {
      modelValue: _ctx.text[_ctx.resultIndex][_ctx.kartePartsIndex],
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.text[_ctx.resultIndex][_ctx.kartePartsIndex] = $event)),
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(_component_acu_parts_modal, {
      ref: "acuPartsRef",
      onYes: _ctx.onYesParts
    }, null, 8, ["onYes"])
  ], 2))
})